import { OrderedMap } from 'immutable';
import CrossChannelParameters from './CrossChannelParameters';
import CrossChannelMode from './CrossChannelModeSpec';

import modeConfig from '../../pages/crosschannel/config/modeConfig';
import modesPerOrg from '../../pages/crosschannel/config/modesPerOrg';

const newJobForOrganization = (organizationId) => (
  new CrossChannelParameters({
    modeOptions: new OrderedMap(
      modesPerOrg[organizationId].map((modeKey) =>
        [modeKey,
        new CrossChannelMode({
          key: modeKey,
          displayLabel: modeConfig[modeKey].displayLabel,
          selected: modeConfig[modeKey].initialSelected,
          impactFactor: modeConfig[modeKey].initialImpactFactor,
          discount: modeConfig[modeKey].initialDiscount,
          flightSize: modeConfig[modeKey].initialFlightSize,
          costText: modeConfig[modeKey].costText,
          costTooltip: modeConfig[modeKey].costTooltip,
          frequencyText: modeConfig[modeKey].frequencyText,
          frequencyTooltip: modeConfig[modeKey].frequencyTooltip,
          percentText: modeConfig[modeKey].percentText,
          percentTooltip: modeConfig[modeKey].percentTooltip,
          impactFactorText: modeConfig[modeKey].impactFactorText,
          impactFactorTooltip: modeConfig[modeKey].impactFactorTooltip,
          discountTooltip: modeConfig[modeKey].discountTooltip,
          flightText: modeConfig[modeKey].flightText,
          flightTooltip: modeConfig[modeKey].flightTooltip,
          icon: modeConfig[modeKey].icon,
        })],
    )),
  })
);

export default newJobForOrganization;
